import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { BookCategory } from "@modules/bookCategories/types";
import { BookCategoryFormValues } from "@modules/bookCategories/validations";

export async function editBookCategoryService(
  id: string,
  data: BookCategoryFormValues
): Promise<BookCategory> {
  if (typeof data.image === "string") {
    delete data.image;
  }

  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: bookCategory } = await api.patch<BookCategory>(
    `v1/book_category_admin/${id}/`,
    formatedData,
    { headers }
  );

  return bookCategory;
}
